import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";

import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import FormBox from "../../component/FormBox/FormBox";
import useCustomYupTest from "../../CustomYup/CustomYupTest";
import CustomTooltip from "../../component/CustomTooltip/CustomTooltip";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from "@material-ui/core";
import { isEmpty } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, setFieldValues } from "../../redux/action";
import { getFieldValuesByStep, getFormId } from "../../redux/selector";
import CustomHKID from "../../inputComponent/CustomHKID/CustomHKID";
import useCustomYup from "../../CustomYup/CustomYup";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import CustomSelect from "../../inputComponent/CustomSelect/CustomSelect";
import CustomSchoolSelect from "../../inputComponent/CustomSchoolSelect/CustomSchoolSelect";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CustomRadioGroup from "../../inputComponent/CustomRadioGroup/CustomRadioGroup";

export default function InputSample() {
    const formId = useSelector(getFormId());
    const stepName = "Input";

    //const { engNumFiveSPCharTest } = useCustomYupTest();

    const { t, i18n } = useTranslation();

    const {
        hkidTest,
        telTest,
        emailTest,
        engNumFiveSPCharTest,
        engNumEightSPCharTest,
        chineseOnlyTest,
    } = useCustomYupTest();

    const dispatch = useDispatch();
    let defaultValues = useSelector(getFieldValuesByStep(stepName));
    const initialDefaultValues = {
        hkid: "",
        price: null,
        weight: null,
        phoneNo: "",
        email: "",
        engNumFiveSPchar: "",
        chinese: "",
        title: "",
        scrn: "",
    };
    if (isEmpty(defaultValues)) {
        defaultValues = initialDefaultValues;
    }
    const yupSchema = yup.object().shape({
        hkid: yup
            .string()
            .required(t("errorMsg.required"))
            .test(...hkidTest),
        price: yup
            .number()
            .min(1, t("errorMsg.number.rule"))
            .integer(t("errorMsg.number.integer"))
            .typeError(t("errorMsg.number.rule")),
        weight: yup
            .number()
            .min(1, t("errorMsg.number.rule"))
            .integer(t("errorMsg.number.integer"))
            .typeError(t("errorMsg.number.rule")),
        phoneNo: yup
            .string()
            .required(t("errorMsg.required"))
            .test(...telTest),
        email: yup
            .string()
            .required(t("errorMsg.required"))
            .test(...emailTest),
        engNumFiveSPchar: yup
            .string()
            .required(t("errorMsg.required"))
            .test(
                ...engNumFiveSPCharTest(
                    t(
                        "some_translation_key",
                        "English Numeric Five Special Chracters"
                    )
                )
            ),
        chinese: yup
            .string()
            .required(t("errorMsg.required"))
            .test(
                ...chineseOnlyTest(t("some_translation_key", "Chinese Only"))
            ),
    });

    const shortText1 =
        "This is a sample text. This is a sample text. This is a sample text.";
    const shortText2 =
        "This is a sample text. This is a sample text. This is a sample text.";

    const longText1 =
        "Welcome to the website of the Education Bureau.Quality education is the key to nurturing talent, which is crucial for the development of the society.";
    const longText2 =
        "Our goal is to nurture future generations to become citizens who are socially responsible and equipped with a sense of national identity, love for Hong Kong and international perspectives.We need to create, for students, teachers, principals and parents, a learning and teaching environment that is stable, caring, inspiring and satisfying. Hence, students at kindergarten, primary, secondary and tertiary levels can identify their strengths and interests in the learning process, progress continuously, and establish themselves intellectually and morally. As the Principal Official in charge of education, I will work with my professional team to continue offering professional services and maintaining close liaison and communication with stakeholders of the education sector.";
    const longText3 =
        " The success of education hinges on the collaborative efforts of people who care about the next generation. Let us work together to refine our education system and enhance the quality of education for the benefit of each and every student.";

    const {
        register,
        handleSubmit,
        control,
        formState,
        clearErrors,
        reset,
        watch,
        getValues,
        setValue,
    } = useForm({
        defaultValues,
        mode: "onBlur",
        resolver: yupResolver(yupSchema),
    });

    const onStepSubmit = (formData) => {
        //onStepSubmit
        console.log("onStepSubmit, formData:", formData);
        dispatch(setFieldValues(stepName, formData));
        dispatch(setCurrentStep("Confirmation"));
    };

    const onStepError = (errors) => {
        //onStepError
        console.log("onStepError, errors: ", errors);
    };

    const onPrev = () => {};

    const onReset = () => {
        reset(initialDefaultValues);
    };

    const errors = formState.errors;

    return (
        <form noValidate>
            <FormBox header="Input Sample">
                <Box p={5}>
                    <Box mb={6}>
                        <CustomHKID
                            label={t("some_translation_key", "身份證號碼")}
                            control={control}
                            name="hkid"
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t("some_translation_key", "金額")}
                            inputProps={{
                                ...register(`price`),
                            }}
                            error={errors?.[`price`]}
                            prefixUnit="$"
                            type="number"
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t("some_translation_key", "重量")}
                            inputProps={{
                                ...register(`weight`),
                            }}
                            error={errors?.[`weight`]}
                            unit="kg"
                            type="number"
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t("some_translation_key", "電話號碼")}
                            inputProps={{
                                ...register(`phoneNo`),
                            }}
                            error={errors?.[`phoneNo`]}
                            type="tel"
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t("some_translation_key", "電郵地址")}
                            inputProps={{
                                ...register(`email`),
                            }}
                            error={errors?.[`email`]}
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t(
                                "some_translation_key",
                                "English Numeric Five Special Character"
                            )}
                            inputProps={{
                                ...register(`engNumFiveSPchar`),
                            }}
                            error={errors?.[`engNumFiveSPchar`]}
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomRadioGroup
                            label={t("some_translation_key", "稱謂")}
                            control={control}
                            name="title"
                            options={t(`common.titleOption`, {
                                returnObjects: true,
                            })}
                            checkBoxIcon
                            row
                        />
                        {/* <FormControl component="fieldset">
                            <InputLabel shrink htmlFor="title">
                                {t("some_translation_key", "稱謂")}
                                {t("common.colon")}
                                <Box component="span" className="danger">
                                    *
                                </Box>
                            </InputLabel>
                            <Controller
                                control={control}
                                name="title"
                                render={({ field }) => (
                                    <RadioGroup
                                        row
                                        aria-label="title"
                                        value={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                        }}
                                    >
                                        {Object.entries(
                                            t(`common.titleOption`, {
                                                returnObjects: true,
                                            })
                                        ).map(([key, value]) => (
                                            <FormControlLabel
                                                key={key}
                                                value={key}
                                                control={
                                                    <Radio
                                                        checkedIcon={
                                                            <CheckBoxIcon />
                                                        }
                                                        icon={
                                                            <CheckBoxOutlineBlankIcon />
                                                        }
                                                    />
                                                }
                                                label={value}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl> */}
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t("some_translation_key", "中文姓名")}
                            inputProps={{
                                ...register(`chinese`),
                            }}
                            error={errors?.[`chinese`]}
                            toolTip={
                                <CustomTooltip
                                    title={
                                        <React.Fragment>
                                            {t(
                                                "some_translation_key",
                                                shortText1
                                            )}
                                            <br />
                                            {t(
                                                "some_translation_key",
                                                shortText2
                                            )}
                                        </React.Fragment>
                                    }
                                />
                            }
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t(
                                "some_translation_key",
                                "Tooltip with less than 150 characters"
                            )}
                            toolTip={<CustomTooltip multiLine={[longText1]} />}
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomTextField
                            label={t(
                                "some_translation_key",
                                "Tooltip with more than or equal to 700 characters"
                            )}
                            toolTip={
                                <CustomTooltip
                                    multiLine={[
                                        longText1,
                                        longText2,
                                        longText3,
                                    ]}
                                />
                            }
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomSelect
                            control={control}
                            label={t("some_translation_key", "月份")}
                            name={"month"}
                            options={t("common.monthOption", {
                                returnObjects: true,
                            })}
                            showError={false}
                            toolTip={
                                <CustomTooltip title="Please input a month" />
                            }
                        />
                    </Box>
                    <Box mb={6}>
                        <CustomSchoolSelect
                            control={control}
                            schoolNameFieldName="scrn"
                            label={t("common.schoolName")}
                        />
                    </Box>
                </Box>
            </FormBox>
            <FormBox style={{ border: "0px" }}>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="secondary"
                        className="secBtn"
                        onClick={() => onPrev()}
                    >
                        {t("common.button.back")}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        className="secBtn"
                        onClick={() => onReset()}
                    >
                        {t("common.button.clear")}
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                        {t("common.button.next")}
                    </Button>
                </Box>
            </FormBox>
        </form>
    );
}
